import { useMemo } from "react";
import { marked } from "marked";

/**
 * Renders the league's markdown articles.
 *
 * The archive is written by the Commissioner and the news bot, so it is
 * trusted input — but rendering it as HTML still means anything pasted into an
 * article body would run, so raw HTML is stripped before parsing rather than
 * relying on the author to behave.
 */
function stripHtml(markdown: string): string {
  return markdown
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/<\/?[a-z][^>]*>/gi, "");
}

export default function Markdown({ children }: { children: string }) {
  const html = useMemo(() => {
    const parsed = marked.parse(stripHtml(children), {
      async: false,
      gfm: true,
      breaks: false,
    }) as string;
    // Wide stat tables are common in these pieces; let them scroll on their own.
    return parsed.replace(
      /<table>/g,
      '<div class="table-wrap"><table>',
    ).replace(/<\/table>/g, "</table></div>");
  }, [children]);

  return (
    <div
      className="prose-mpl max-w-none"
      // Input is stripped of HTML above, so only markdown-generated markup here.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
